import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import React from 'react';


const DetailsTable = ({ entries, entityName, dialogName, translate }) => (
	<React.Fragment>
		<Box mt={2}>
			<Typography variant='h6' gutterBottom>
				{translate(`osfc.dialogs.${dialogName}.section.${entityName}.title`)}
			</Typography>
			<Table size="small">
				<TableHead>
					<TableRow>
						{Object.keys(entries[0]).map((entryKey, cellIndex) => (
							<TableCell 
								variant='head' 
								style={{ fontWeight: "bold" }} 
								key={cellIndex}
							>
								{translate(`osfc.dialogs.${dialogName}.section.${entityName}.fields.${entryKey}`)}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{entries.map((entry, rowIndex) => (
						<TableRow key={rowIndex}>
							{Object.values(entry).map((entryValue, cellIndex) => (
								<TableCell 
									variant='body' 
									key={`${rowIndex}-${cellIndex}`}
								>
									{entryValue}
								</TableCell>
							))}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</Box>
	</React.Fragment>
);


export default DetailsTable;
